import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { DiagramPageData } from "../types";
import { InfoCard } from "./InfoCard";
import { useStyles } from "./styles";

type ToolsAndNotesProps = {
  pageData: DiagramPageData;
};

export const ToolsAndNotes = ({ pageData }: ToolsAndNotesProps) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const { toolboxesAndAccessories, customNotes } = pageData;

  const resolveNote = (note: string) =>
    note.startsWith("WORK_ORDER.") ? t(note) : note;

  if (!toolboxesAndAccessories?.length && !customNotes?.notes?.length) {
    return null;
  }

  return (
    <>
      {toolboxesAndAccessories?.length ? (
        <InfoCard
          titleKey="WORK_ORDER.DIAGRAM.PAGE_3.SECTIONS.TOOLBOXES_ACCESSORIES.TITLE"
          fields={toolboxesAndAccessories}
          singleColumn
          fullWidth
          autoHeight
        />
      ) : null}

      {customNotes?.notes?.length ? (
        <Box className={styles.customNotesSection}>
          <Typography className={styles.cardTitle}>
            {t(customNotes.titleKey)}
          </Typography>
          <Box className={styles.customNotesList}>
            {customNotes.notes.map((note) => (
              <Box key={note} className={styles.customNoteItem}>
                <Typography component="span" className={styles.customNoteText}>
                  {resolveNote(note)}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      ) : null}
    </>
  );
};
